import React, { useState, useContext, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert
} from "@mui/material";
import { AuthContext } from "../../AuthContext/AuthContext";

const ReferralRewardForm = ({ open, onClose, currentItem, onSubmit }) => {
  const { userId } = useContext(AuthContext);
  const [formData, setFormData] = useState(
    currentItem || { 
      user_id: userId,
      no_of_users: "",
      credit_points: 0
    }
  );

   // Reset form when currentItem changes
  useEffect(() => {
    if (currentItem) {
      setFormData({
        user_id: userId,
        no_of_users: currentItem.no_of_users || "",
        credit_points: currentItem.credit_points || 0
      });
    } else {
      setFormData({
        user_id: userId,
        no_of_users: "",
        credit_points: 0
      });
    }
  }, [currentItem, open, userId]);

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      // Validate form data
      if (!formData.no_of_users) {
        throw new Error("Please fill all required fields");
      }
      
      if (!formData.credit_points) {
        throw new Error("Credit points are required");
      }

      await onSubmit(formData);
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {currentItem ? "Edit Referral Reward" : "Add New Referral Reward"}
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
          <TextField
            label="Number of Users"
            name="no_of_users"
            type="number"
            value={formData.no_of_users}
            onChange={handleChange}
            fullWidth
            required
          />
          
          <TextField
            label="Credit Points"
            name="credit_points"
            type="number"
            value={formData.credit_points}
            onChange={handleChange}
            fullWidth
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          {currentItem ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReferralRewardForm;